import usePurchaseTrainingContent from './usePurchaseTrainingContent';

export default usePurchaseTrainingContent;
